import * as Icon from "@ant-design/icons";
import { Col, Flex, Form, Modal, Row, Tag } from "antd";
import Search from "antd/lib/input/Search";
import { ColumnsType, TableProps } from "antd/es/table";
import { useEffect, useState } from "react";
import { CentroCustoDtoModel } from "../../models/centroCusto/centroCustoDtoModel";
import { setEntityCentroCusto, setBuscaCentroCusto, setModalCadastrarCentroCusto, setModalDeletarCentroCusto } from "../../redux/slices/centroCusto/centroCustoSlice";
import { setTitle } from "../../redux/slices/configuracoes/configuracoesSlice";
import { atualizarCentroCustoAtivo, buscarCentroCusto, deletarCentroCusto } from "../../services/centroCustoService";
import { useAppDispatch, useAppSelector } from "../../util/hooks";
import { AtivoModel } from "../../models/ativoModel";
import CadastroEdicaoCentroCusto from "./modals/cadastrar";
import { FilterValue } from "antd/es/table/interface";
import { BuscaCentroCustoModel } from "../../models/centroCusto/buscaCentroCustoModel";
import { ItemMenuAcoes } from "../../models/sistema/itemMenuAcoes";
import AcoesComponent from "../../components/table/acoesComponent";
import { ButtonComponent } from "../../components/button/cadastrar";
import TableComponent from "../../components/table/tableComponent";
import { removeFilhos } from "../../util/functions/removeFilhos";
import MensagemModal from "../../components/modal/mensagem";
import { SwitchComponent } from "../../components/button/switch";

const CentroCusto = () => {
  //estados globais
  const centroCustoState = useAppSelector((state) => state.centroCusto);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [filteredInfo, setFilteredInfo] = useState<Record<string, FilterValue | null | string>>({});

  const editar = Object.values(centroCustoState.entity).length !== 0;

  useEffect(() => {
    dispatch(setTitle("CENTROS DE CUSTO"));
    dispatch(buscarCentroCusto({ ...centroCustoState.busca, ativo: true }));
  }, []);

  const goCadastrar = () => {
    dispatch(setEntityCentroCusto({}));
    dispatch(setModalCadastrarCentroCusto(true));
  };

  const goEditar = (value: CentroCustoDtoModel) => {
    dispatch(setEntityCentroCusto(value));
    dispatch(setModalCadastrarCentroCusto(true));
  };

  const closeModalCadastrar = () => {
    dispatch(setModalCadastrarCentroCusto(false));
  };

  const goDeletar = (value: CentroCustoDtoModel) => {
    dispatch(setEntityCentroCusto(value));
    dispatch(setModalDeletarCentroCusto(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarCentroCusto(false));
  };

  const onChangeAtivo = (value: CentroCustoDtoModel) => {
    let args: AtivoModel = {
      id: value.id,
      ativo: !value.ativo,
    };
    dispatch(atualizarCentroCustoAtivo({ value: args, busca: centroCustoState.busca }));
  };

  const onSearch = (value: string) => {
    let busca: BuscaCentroCustoModel = { ...centroCustoState.busca, pesquisar: value };

    dispatch(setBuscaCentroCusto(busca));
    dispatch(buscarCentroCusto(busca));
  };

  const onChangeTable: TableProps<CentroCustoDtoModel>["onChange"] = (pagination, filters, sorter, extra) => {
    setFilteredInfo(filters);

    let busca: BuscaCentroCustoModel = { ...centroCustoState.busca };

    if (filters.ativo !== null) {
      if (filters.ativo.length === 2) {
        busca.ativo = null;
      }
      if (filters.ativo.length === 1) {
        if (filters.ativo[0] === "true") {
          busca.ativo = true;
        }
        if (filters.ativo[0] === "false") {
          busca.ativo = false;
        }
      }
    } else {
      busca.ativo = null;
    }

    dispatch(setBuscaCentroCusto(busca));
    dispatch(buscarCentroCusto(busca));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <Icon.EditOutlined />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <Icon.DeleteOutlined />,
      function: (item: any) => goDeletar(item),
      disabled: (item: any) => item.filhos !== undefined,
    },
  ];

  const columns: ColumnsType<CentroCustoDtoModel> = [
    {
      title: "CENTRO DE CUSTO",
      dataIndex: "denominacao",
      width: 300,
    },
    {
      title: "TIPO",
      align: "center",
      width: 100,
      filters: [
        {
          text: "Receita",
          value: "receita" as any,
        },
        {
          text: "Despesa",
          value: "despesa" as any,
        },
      ],
      onFilter: (_, record: any) => {
        let verifica: any = Object.keys(filteredInfo).length;
        if (verifica !== 0) {
          let chaves: any = Object.values(filteredInfo)[0];
          if (chaves !== null) {
            if (chaves.length === 2) {
              return record.despesa || record.receita;
            } else {
              return chaves[0] === "despesa" ? record.despesa : record.receita;
            }
          } else {
            return record;
          }
        }
        return record.receita;
      },
      render: (_, record) => (
        <Flex justify="center">
          {record.receita && <Tag>Receita</Tag>}
          {record.despesa && <Tag>Despesa</Tag>}
        </Flex>
      ),
    },
    {
      title: "ATIVO",
      dataIndex: "ativo",
      width: 100,
      filters: [
        {
          text: "Ativo",
          value: "true" as any,
        },
        {
          text: "Inativo",
          value: "false" as any,
        },
      ],
      defaultFilteredValue: ["true" as any],
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => {
        return <>{record.filhos?.length === 0 && <SwitchComponent onChange={() => onChangeAtivo(record)} checked={record.ativo} />}</>;
      },
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={items} />,
    },
  ];

  return (
    <Flex vertical>
      <Form layout="vertical">
        <Row gutter={12} align="bottom">
          <Col span={20}>
            <Flex gap={12}>
              <Form.Item label="Pesquisar" name="pesquisar">
                <Search allowClear placeholder="Denominação ou Abreviação" onSearch={onSearch} className="searchInput" enterButton style={{ width: 400 }} />
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end">
              <ButtonComponent onClick={goCadastrar} />
            </Flex>
          </Col>
        </Row>
      </Form>
      <TableComponent
        loading={centroCustoState.loading}
        data={removeFilhos(centroCustoState.list)}
        columns={columns}
        expandable={{
          childrenColumnName: "filhos",
          expandRowByClick: true,
        }}
        tableProps={{
          className: "tableCentroCusto",
          onChange: onChangeTable,
        }}
      />
      <Modal
        title={editar ? "EDITAR CENTRO DE CUSTO" : "NOVO CENTRO DE CUSTO"}
        centered
        width={835}
        open={centroCustoState.modalCadastrar}
        onCancel={closeModalCadastrar}
        footer={null}
        destroyOnHidden
      >
        <CadastroEdicaoCentroCusto />
      </Modal>
      <Modal title={"REMOVER CENTRO DE CUSTO"} centered width={350} open={centroCustoState.modalDeletar} onCancel={closeModalDeletar} footer={null} destroyOnHidden>
        <MensagemModal
          text="Deseja remover o centro de custo?"
          action={deletarCentroCusto({ value: centroCustoState.entity.id, busca: centroCustoState.busca })}
          close={setModalDeletarCentroCusto(false)}
        />
      </Modal>
    </Flex>
  );
};

export default CentroCusto;
